module.exports = __webpack_public_path__ + "static/media/auth-logo-rtl.1b992eae.svg";